import React, { Component } from 'react';
import './App.css';
import Sidebar from './components/sidebar'
import Introduction from './components/introduction'
import About from './components/about'
import Projects from './components/projects'
import Resources from './components/resources'
import Timeline from './components/timeline'
import Footer from './components/footer'


class App extends Component {
  render() {
    return (
      <div id="davidvallejo-page">
        <div id="container-wrap">
         	<Sidebar></Sidebar>
				<div id="davidvallejo-main">
					<Introduction></Introduction>
					<About></About>
          <Projects></Projects>
          <Resources></Resources>
					<Timeline></Timeline>
          <Footer></Footer>
          	</div>
      	</div>
      </div>
    );
  }
}

export default App;
